import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionType } from "../../../Pages/QuestionType/IQuestionType";

export const AddQuestionTypeSlice = createSlice({
  name: "AddQuestionTypeSlice",
  initialState: {} as IReduxState<IQuestionType>,
  reducers: {
    addQuestionType: (state, _: PayloadAction<IQuestionType>) => {
      state.isLoading = true;
    },
    successaddQuestionType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddQuestionType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddQuestionTypeResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addQuestionType,
  failureaddQuestionType,
  successaddQuestionType,
  clearAddQuestionTypeResponse,
} = AddQuestionTypeSlice.actions;

export default AddQuestionTypeSlice.reducer;
